// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"4f7b7c70","279":"e2984bb9","314":"f4d289e8","339":"031b1eaa","406":"f0a161cd","436":"1e3eacde","447":"017db47b","624":"2c446411","641":"518a951e","731":"8fd6d374","919":"37582e4e","973":"3fe0f83a","978":"d3ee1e60","979":"11584fa8"}[chunkId] + ".chunk.js";
};